"use client";
var __defProp = Object.defineProperty;
var __name = (target, value) => __defProp(target, "name", { value, configurable: true });

// src/components/atoms/container.tsx
import { cn } from "@base/utils/cn";
import { jsx } from "react/jsx-runtime";
var containerSizes = {
  "no-padding": "mx-auto w-full md:max-w-2xl lg:max-w-7xl",
  xs: "mx-auto w-full px-4 sm:px-6 md:max-w-2xl md:px-4 lg:px-2",
  sm: "mx-auto w-full px-4 sm:px-6 md:max-w-2xl md:px-4 lg:max-w-4xl lg:px-12",
  md: "mx-auto w-full px-4 sm:px-6 md:max-w-2xl md:px-4 lg:max-w-5xl lg:px-8",
  lg: "mx-auto w-full px-4 sm:px-6 lg:max-w-7xl lg:px-8",
  xl: "mx-auto w-full px-4 sm:px-6 lg:max-w-[96rem] lg:px-8"
};
function Container({ size = "lg", className, ...props }) {
  return /* @__PURE__ */ jsx("div", { "data-slot": "container", className: cn(containerSizes[size],
  className), ...props });
}
__name(Container, "Container");
export {
  Container,
  containerSizes
};
